import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ManageUsersService } from 'src/app/modules/manage-users/services/manage-users.service';
import { ASX_DATA_CAPTURE_REPORTING_CODE, CP_RESERVE, CP_RESOURCE, ENDORSER_NEW_CP_QP_AND_ACK, ENDORSER_RESERVE, ENDORSER_RESOURCE, ENDORSER_RESOURCES_AND_RESERVES, EXTERNAL_ENDORSER_RESERVE, EXTERNAL_ENDORSER_RESOURCE, NOTIFICATION_ERROR, OWNER_SHIPNUMBER_LEVEL_4_EXTERNAL_RESERVE_ENDORSER, OWNER_SHIPNUMBER_LEVEL_4_EXTERNAL_RESOURCE_ENDORSER, OWNER_SHIPNUMBER_LEVEL_4_HEAD_OF_GEOSCIENCE_RESERVE, OWNER_SHIPNUMBER_LEVEL_4_HEAD_OF_GEOSCIENCE_RESOURCE, OWNER_SHIPNUMBER_LEVEL_5_CP_RESERVE, OWNER_SHIPNUMBER_LEVEL_5_CP_RESOURCE, OWNER_SHIPNUMBER_LEVEL_5_QP_RESERVE, OWNER_SHIPNUMBER_LEVEL_5_QP_RESOURCE, QP_RESERVE, QP_RESOURCE, RESERVE, RESOURCE, REVIEWER, US_SEC_DATA_CAPTURE_REPORTING_CODE } from 'src/app/shared/constants/constant';
import { NotificationAlert } from 'src/app/shared/models/notificationAlert.model';
import {
  UserDetail,
  UserDetails,
} from 'src/app/shared/models/userDetail.model';
import { AnnualReportingDetails } from '../../models/manageWorkflow.model';

@Component({
  selector: 'app-update-action-pop-up',
  templateUrl: './update-action-pop-up.component.html',
  styleUrls: ['./update-action-pop-up.component.scss'],
})
export class UpdateActionPopUpComponent implements OnInit {
  public searchUserResult: UserDetail[] = [];
  public selectedUserDetail: UserDetail = null;
  public alert: NotificationAlert;
  @Input() disableBtn = true;
  @Input() selectedWorkflow: AnnualReportingDetails;
  @Input() isCPQPNomination = false;
  public usersList: UserDetails[] = [];
  public profileForm: FormGroup;
  public labelName: string;
  public showLoader = false;
  @Output() onClose = new EventEmitter<any>();
  @Output() onUpdateActionSelect = new EventEmitter<any>();

  constructor(private manageUserService: ManageUsersService) {}

  ngOnInit(): void {
    this.getSelectedWorkflowUserDetails(this.manageUserService.getAllExistingUsers());
    if (!this.usersList || !this.usersList.length) {
      this.showLoader = true;
      this.manageUserService.getAllUsers().subscribe((response) => {
        this.showLoader = false;
        this.getSelectedWorkflowUserDetails(response);
      });
    }
    this.profileForm = new FormGroup({
      user: new FormControl(null, [Validators.required]),
    });
  }
  public clearUser(): void {
    this.selectedUserDetail = null;
    this.disableBtn = true;
    this.alert = null;
  }
  public onUserQueryChange(searchQuery): void {
    this.disableBtn = true;

    if (searchQuery.trim() !== '') {
      this.searchUserResult = this.usersList;
    }
  }

  public getSelectedUser(item): void {
    this.selectedUserDetail = item;
  }
  public closePopup(): void {
    this.selectedUserDetail = null;
    this.onClose.emit();
  }
  public update(): void {
    if(this.selectedUserDetail) {
      this.onUpdateActionSelect.emit(this.selectedUserDetail);
    }
  }

  public getSelectedWorkflowUserDetails(users): void {
    if (this.selectedWorkflow && users) {
      const workflowStatus = this.selectedWorkflow.workflowStatus;
      if (workflowStatus == '1') {
        if (this.selectedWorkflow.reportingCode === ASX_DATA_CAPTURE_REPORTING_CODE) {
          if (this.selectedWorkflow.wfLevel1OwnershipType && this.selectedWorkflow.wfLevel1OwnershipType === OWNER_SHIPNUMBER_LEVEL_5_CP_RESOURCE) {
            this.labelName = CP_RESOURCE;
          } else if (this.selectedWorkflow.wfLevel1OwnershipType && this.selectedWorkflow.wfLevel1OwnershipType === OWNER_SHIPNUMBER_LEVEL_5_CP_RESERVE) {
            this.labelName = CP_RESERVE;
          }
        } else if (this.selectedWorkflow.reportingCode === US_SEC_DATA_CAPTURE_REPORTING_CODE) {
          if (this.selectedWorkflow.wfLevel1OwnershipType && this.selectedWorkflow.wfLevel1OwnershipType === OWNER_SHIPNUMBER_LEVEL_5_QP_RESOURCE) {
            this.labelName = QP_RESOURCE;
          } else if (this.selectedWorkflow.wfLevel1OwnershipType && this.selectedWorkflow.wfLevel1OwnershipType === OWNER_SHIPNUMBER_LEVEL_5_QP_RESERVE) {
            this.labelName = QP_RESERVE;
          }
        }
        this.usersList = users.filter(element => (element.roleTypeCode == '2.2' || element.roleTypeCode == '2.3'));
      } else if (workflowStatus == '2') {
        this.labelName = REVIEWER;
        this.usersList = users.filter(element => (element.roleTypeCode == '2.3' || element.roleTypeCode == '2.4'));
      } else if (workflowStatus == '3' || workflowStatus == '4' || workflowStatus == '5' || workflowStatus == '6') {
        if (this.isCPQPNomination) {
          if (workflowStatus == '3' || workflowStatus == '5') {
            this.labelName = ENDORSER_NEW_CP_QP_AND_ACK;
          } else if(workflowStatus == '4') {
            if (this.selectedWorkflow.wfLevel4OwnershipType && this.selectedWorkflow.wfLevel4OwnershipType === OWNER_SHIPNUMBER_LEVEL_4_HEAD_OF_GEOSCIENCE_RESOURCE) {
              this.labelName = ENDORSER_RESOURCE;
            } else if (this.selectedWorkflow.wfLevel4OwnershipType && this.selectedWorkflow.wfLevel4OwnershipType === OWNER_SHIPNUMBER_LEVEL_4_HEAD_OF_GEOSCIENCE_RESERVE) {
              this.labelName = ENDORSER_RESERVE;
            }
          } else if(workflowStatus == '6') {
            if (this.selectedWorkflow.wfLevel4OwnershipType && this.selectedWorkflow.wfLevel4OwnershipType === OWNER_SHIPNUMBER_LEVEL_4_EXTERNAL_RESOURCE_ENDORSER) {
              this.labelName = EXTERNAL_ENDORSER_RESOURCE;
            } else if (this.selectedWorkflow.wfLevel4OwnershipType && this.selectedWorkflow.wfLevel4OwnershipType === OWNER_SHIPNUMBER_LEVEL_4_EXTERNAL_RESERVE_ENDORSER) {
              this.labelName = EXTERNAL_ENDORSER_RESERVE;
            }
          }
        } else {
          if (workflowStatus == '3') {
            if (this.selectedWorkflow.wfLevel3OwnershipType && this.selectedWorkflow.wfLevel3OwnershipType === OWNER_SHIPNUMBER_LEVEL_4_HEAD_OF_GEOSCIENCE_RESOURCE) {
              this.labelName = ENDORSER_RESOURCE;
            } else if (this.selectedWorkflow.wfLevel3OwnershipType && this.selectedWorkflow.wfLevel3OwnershipType === OWNER_SHIPNUMBER_LEVEL_4_HEAD_OF_GEOSCIENCE_RESOURCE) {
              this.labelName = ENDORSER_RESERVE;
            }
          } else if (workflowStatus == '5') {
            if (this.selectedWorkflow.wfLevel3OwnershipType && this.selectedWorkflow.wfLevel3OwnershipType === OWNER_SHIPNUMBER_LEVEL_4_EXTERNAL_RESOURCE_ENDORSER) {
              this.labelName = EXTERNAL_ENDORSER_RESOURCE;
            } else if (this.selectedWorkflow.wfLevel3OwnershipType && this.selectedWorkflow.wfLevel3OwnershipType === OWNER_SHIPNUMBER_LEVEL_4_EXTERNAL_RESERVE_ENDORSER) {
              this.labelName = EXTERNAL_ENDORSER_RESERVE;
            }
          } else if (workflowStatus == '4' || workflowStatus == '6') {
            this.labelName = ENDORSER_RESOURCES_AND_RESERVES;
          }
        }
        this.usersList = users.filter(element => element.roleTypeCode == '2.5');
      }
    }
  }
}